import Section from "../Section";
import { useTranslations } from "../../contexts/Translation";
import { H1 } from "../Headers/Headings";
import Button from "../Button/Button";
import { useApiData } from "../../contexts/ApiData";
import { useSearchParams } from "react-router-dom";
import { InfoMessageBox } from "../InfoMessage/InfoMessageBox";
import styles from "./ActivateSubscription.module.css";

export const ActivateSubscription = () => {
  const t = useTranslations("subscription");
  const { post } = useApiData();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get("plan") ?? "fj-single-yearly";
  const isCancelled = searchParams.get("cancelled") === "true";

  const getCheckoutSessionUrl = async () => {
    const response = await post("/payment/create-checkout-session", { lookupKey: plan });
    window.location.href = response.gotoUrl;
  };

  return (
    <Section>
      <H1>{t("activateSub")}</H1>
      {isCancelled && <InfoMessageBox body={t("checkoutCancelled")} testId='activate-subscription-cancelled-notice' />}
      <p className={styles.paragraph}>{t("subscriptionOrderText")}</p>
      <div className={styles.actions}>
        <Button onClick={getCheckoutSessionUrl} testId='activate-subscription-checkout-button'>
          {t("goToCheckout")}
        </Button>
      </div>
      <p className={styles.paragraph}>{t("subscriptionOrderInfo")}</p>
    </Section>
  );
};
